export default "__VITE_ASSET__DtVz$oU3__"